import { isNote } from "../constants/notes";
import { isPredefinedRangeType, Range } from "../constants/ranges";
import { logger } from "./logger";

const key = "user-set-range";

export function storeUserRangeInStorage(range: Range) {
  const serialized = serializeRange(range);

  try {
    localStorage.setItem(key, serialized);
  } catch (e) {
    logger("storeUserRangeInStorage: error", e);
  }
}

export function getUserRangeFromStorage(): Range | null {
  return deserializeRange(localStorage.getItem(key));
}

function serializeRange(range: Range): string {
  return JSON.stringify(range);
}

function deserializeRange(str: string | null): Range | null {
  if (!str) {
    return null;
  }

  try {
    const parsedRange = JSON.parse(str);
    const lowString: string | null =
      typeof parsedRange.low === "string" ? parsedRange.low : null;
    const highString: string | null =
      typeof parsedRange.high === "string" ? parsedRange.high : null;
    const rangeString: string | null =
      typeof parsedRange.range === "string" ? parsedRange.range : null;

    if (
      lowString &&
      highString &&
      rangeString &&
      isNote(lowString) &&
      isNote(highString)
    ) {
      const predefinedRange = isPredefinedRangeType(rangeString)
        ? rangeString
        : null;

      return {
        low: lowString,
        high: highString,
        range: predefinedRange ? predefinedRange : "custom",
      };
    }
  } catch (e) {
    logger("deserializeRange: error", e);
  }

  return null;
}
